import { Link } from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { useEffect } from "react";

export const SwReset = () => {
  useEffect(() => {
    async function resetSW() {
      // The two reads are independent, so kick them off together.
      const [regs, keys] = await Promise.all([
        navigator.serviceWorker.getRegistrations(),
        caches.keys(),
      ]);

      await Promise.all([
        ...regs.map((r) => r.unregister()),
        ...keys.map((k) => caches.delete(k)),
      ]);

      // tell user to close tabs + reopen
    }

    resetSW();
  }, []);

  return (
    <div>
      <Link href="/">
        <Trans>OK</Trans>
      </Link>
    </div>
  );
};
